import { fetchDemandedProducts } from "@api/procurements/procurement";
import { useEffect, useState } from "react";

export const useSelectedProducts = () => {
  const [selectedProducts, setSelectedProducts] = useState<any>([]);
  const [query, setQuery] = useState({
    demandIds: [],
  });

  const handleQuery = (key: string, value: any) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    fetchDemandedProducts(query)
      .then((data) => setSelectedProducts(data.data?.selectedAggregateItems))
      .catch((err) => console.log(err));
  }, [query]);

  return {
    handleQuery,
    selectedProducts,
  };
};
